import { render } from "./BrowserUnsupported.vue?vue&type=template&id=b4ac88a2"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__